/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=5894f68c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5894f68c&scoped=true&lang=css"

import exportComponent from "D:\\un-app\\ys_wuxie_webview_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5894f68c"]])

export default __exports__